<template>
    <div class="cashier-wrap">
        <div class="cashier">
            <div class="my-card-title">收银台</div>
            <div class="cashier-content">
                <div class="product-info">
                    <div class="product-name">商品信息：STRIKE 280 M2 旋转蒸发仪 硼硅玻璃 立式下沉型</div>
                    <div class="price">订单金额<i>3888.8</i>元</div>
                </div>
                <div class="pay-type-wrap">
                    <div class="pay-type-title">
                        <p>预存支付</p>
                        <div class="tip">余额：￥0</div>
                    </div>
                    <div class="form-check under-line">
                        <input class="form-check-input" type="radio" name="pay-type" id="pay-type0" v-model="pay_type"
                            value="0">
                        <label class="form-check-label custom-label" for="pay-type0">
                            <img src="~@/assets/images/balance_pay.png" alt="">个人预存余额<span class="tip"
                                style="margin-left: 15px;">您还没有预存，预存可以一次开票、多次使用，省去每次开票的麻烦！<router-link
                                    :to="{ path: '/user/recharge' }"><i>立即预存</i></router-link></span>
                        </label>
                    </div>
                    <div class="pay-type-title">
                        <p>其他方式</p>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="pay-type" id="pay-type1" v-model="pay_type"
                            value="1">
                        <label class="form-check-label custom-label" for="pay-type1">
                            <img src="~@/assets/images/wx_pay.png" alt="">微信支付
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="pay-type" id="pay-type2" v-model="pay_type"
                            value="2">
                        <label class="form-check-label custom-label" for="pay-type2">
                            <img src="~@/assets/images/ali_pay.png" alt="">支付宝支付
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="pay-type" id="pay-type3" value="3"
                            v-model="pay_type">
                        <label class="form-check-label custom-label" for="pay-type3">
                            <img src="~@/assets/images/credit_pay.png" alt="">信用金支付<span class="tip"
                                style="margin-left: 15px;">0元下单，先测试后付款， 快去<a href="./mine/index.html?sideBar=1"
                                    target="_blank"><i>实名认证</i></a> ，领取你的5000元信用额度</span>
                        </label>
                    </div>
                    <div style="margin-top: 40px;" v-if="pay_type == 0 || pay_type == 3">
                        <div class="pay-type-title">
                            <p>支付密码</p>
                        </div>
                        <div class="pay-password">
                            <div class="password-inp">
                                <el-input type="password" style="width:200px" v-model="password" placeholder="请输入支付密码">
                                </el-input>
                                <i @click="resetPayPassword">忘记密码？</i>
                            </div>
                            <div class="tip">请输入6位数字支付密码</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pay-btn" @click="handleShowPayQrcode">确认并支付</div>
        </div>
        <!-- 付款二维码 -->
        <pay-qrcode :payNo="payNo" :visible.sync="showQrcodeForm" />
    </div>
</template>
  
<script>

import { addOrder } from "@/api/integral";
import PayQrcode from '@/components/payQrcode';
import ResetPayPassword from '@/components/resetPayPassword';
import path from "path";
export default {
    name: "StoreOrderIntegral",
    components: {
        PayQrcode
    },
    props: {},
    data() {
        return {
            showQrcodeForm: false,
            showResetPayPasswordForm: false,
            payNo: '20230215421',
            loading: true,
            orderId: 0,
            order: {},
            password: null,
            pay_type: 0,

        }
    },
    computed: {

    },
    created() {
        this.orderId = this.$route.query.id

    },
    mounted() {
        this.formatPrice = this.utils.formatPrice
    },
    updated() {

    },
    methods: {
        handleShowPayQrcode() {
            this.showQrcodeForm = true;
        },
        resetPayPassword() {
            this.showResetPayPasswordForm = true;
        },
        // 提交订单
        handleSubmit() {
            // 验证form表单
            const _form = {
                goods_id: this.goodsId,
                address_id: this.addressId
            };
            addOrder(_form)
                .then((response) => {
                    this.loading = false;
                    // 弹出操作提示
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                })
                .catch(() => {
                    this.loading = false;
                });

        }
    }
};
</script>
<style lang="scss" scoped>
.cashier-wrap {
    width: 100%;
    background: #F4F8F9;
    padding: 50px 0 239px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .cashier {
        width: 940px;

        .cashier-content {
            width: 100%;
            padding: 31px 20px 57px 20px;
            box-sizing: border-box;
            background: #FFFFFF;

            .product-info {
                display: flex;
                align-items: center;
                justify-content: space-around;
                font-size: 14px;
                font-weight: 400;
                color: #222222;

                i {
                    font-size: 24px;
                    font-weight: bold;
                    color: #FF6666;
                }
            }

            .pay-type-wrap {
                width: 100%;
                padding: 25px 42px 49px 42px;
                box-sizing: border-box;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                background: #F4F8F9;
                border-radius: 4px;
                margin-top: 30px;

                .pay-type-title {
                    display: flex;
                    align-items: center;
                    column-gap: 35px;
                    margin-bottom: 9px;
                }

                .tip {
                    font-size: 14px;
                    font-weight: 300;
                    color: #A0A9AC;

                    i {
                        color: #00B4E8;
                    }
                }

                .under-line {
                    border-bottom: 1px solid #a7acb22c;
                    margin-bottom: 15px;
                }

                .pay-password {
                    .password-inp {
                        display: flex;
                        align-items: center;
                        column-gap: 20px;
                        margin-bottom: 10px;

                        i {
                            color: #00B4E8;
                            cursor: pointer;
                        }
                    }
                }

                .form-check {
                    display: grid;
                    grid-template-columns: 18px auto;
                    align-items: center;
                    column-gap: 0;
                    line-height: initial;
                    padding: 9px 0;

                    .custom-label {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        font-weight: 300;
                        color: #333333;

                        &>img {
                            width: 30px;
                            height: 30px;
                            margin-left: 20px;
                            margin-right: 20px;
                        }
                    }

                    .total-num {
                        text-align: end;
                        font-size: 14px;
                        font-weight: 300;
                        color: #222222;

                        i {
                            font-size: 14px;
                            font-weight: bold;
                            color: #FF6666;
                        }
                    }
                }
            }
        }

        .pay-btn {
            padding: 10px 40px;
            box-sizing: border-box;
            background: #00B4E8;
            border-radius: 25px;
            font-size: 20px;
            font-weight: 400;
            color: #FFFFFF;
            width: fit-content;
            margin: 45px 0 0 auto;
            cursor: pointer;
        }
    }
}
</style>
  